<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết chính sách bảo hành</h1>
      <div style="float: right">
        <button
          v-if="dataPermission.includes('CNPS_CFG_UPSERT_POLICY')"
          @click="$router.push({ path: `/policy-device/edit/${id}` })"
          class="f12 font-medium btn btn-primary mr-2"
        >
          Sửa
        </button>
        <button @click="changeStatus" class="f12 font-medium btn btn-primary mr-2">
          Đổi trạng thái {{ detail.status === 'ACTIVE' ? 'inactive' : 'active' }}
        </button>
        <button
          @click="$router.push({ path: `/policy-device` })"
          class="f12 font-medium btn btn-outline-secondary"
        >
          <i class="bx bx-left-arrow-alt"></i> Quay lại
        </button>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-sm-12 mb-3 row">
          <div class="col-sm-6">
            <div class="form-detail">
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Mã chính sách<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ detail.code }}</p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Tên chính sách<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ detail.name }}</p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Loại phụ lục<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ detail.typeAppendix | transformData(Config.typeAppendix) }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Loại chính sách thuê<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ detail.type | transformData(Config.optionType) }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Loại thiết bị<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ detail.categoryId | transformData(dataDevice) }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Thời hạn<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ detail.duration }} tháng</p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Doanh số tích lũy<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ detail.totalSales }}</p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Doanh số tối thiểu để được tính tổng<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ detail.minimumSales }}</p>
                </div>
              </div>
            </div>
            <div class="form-detail">
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Người tạo<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ detail.creator ? detail.creator.name : '' }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Ngày tạo<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ detail.createdTime | formatDate('HH:mm, DD/MM/YYYY') }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Ưu tiên<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ detail.priority }}</p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Trạng thái<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ detail.status }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-detail" v-for="(item, index) in detail.priceList" :key="index">
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Tên mức<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ item.name }}</p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Doanh số tối thiểu<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ item.from }}</p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Doanh số tối đa<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ item.to }}</p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Tiền thuê<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ item.price }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import Config from '@/thirdParty/config'
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        showLoading: false,
        id: this.$route.params.id,
        detail: {},
        typeDevice: Config.typeDevice,
        statusCatDevice: Config.statusCatDevice,
        unitDevice: Config.unitDevice,
        Config,
        dataDevice: [],
      }
    },
    components: {},
    created() {
      this.fetchData()
      DeviceService.typeDeviceConfig()
        .then(
          s => s.data?.map(s => ({ id: s.id, text: s.name, abbreviation: s.abbreviation })) ?? []
        )
        .then(
          s =>
            (this.dataDevice = [
              { id: 'OTHER', text: 'Thiết bị khác', abbreviation: 'OTHER' },
              ...s,
            ])
        )
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async changeStatus() {
        try {
          this.showLoading = true
          const data = await DeviceService.changeStatePolicyDevice({
            id: this.id,
          })
          if (data.success) {
            this.showSuccessMx('Đổi trạng thái chính sách bảo hành thành công')
            this.fetchData()
          } else this.showFailMx(data.message)
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      async fetchData() {
        const ids = [this.$route.params.id]
        if (ids) {
          try {
            this.showLoading = true
            const responsive = await DeviceService.getDetailPolicyDevice({ ids })
            if (responsive.code === 1000 && responsive.data.length > 0) {
              this.detail = responsive.data[0]
            }
          } catch (error) {
            console.log(error)
          } finally {
            this.showLoading = false
          }
        }
      },
    },
  }
</script>

<style scoped></style>
